<script>
import {IMaskDirective} from 'vue-imask';
import SpinnerIndicator from "@js/components/Sections/Statuses/SpinnerIndicator.vue";
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import CallbackErrorMessage from "@js/components/Sections/Callback/Components/CallbackErrorMessage.vue";
import PrivacyPolicyAgreementLink from "@js/components/Sections/Contacts/Components/PrivacyPolicyAgreementLink.vue";

export default {
    name: "ServicesTopForm",
    components: {PrivacyPolicyAgreementLink, CallbackErrorMessage, SpinnerIndicator},
    directives: {
        imask: IMaskDirective
    },
    data() {
        return {
            phoneMask: {
                mask: '+7 (000) 000-00-00',
            },
        }
    },
    methods: {
        updatePhone(newPhone) {
            this.callbackStore.forms.services_top_form.data.phone = newPhone;
        },
    },
    setup() {
        const callbackStore = useCallbackFormsStore()

        return {callbackStore}
    }
}
</script>

<template>
    <div
        class="max-h-[430px] max-w-[430px] border border-indigo-600 backdrop-blur-3xl bg-white/50 rounded-xl flex items-center justify-center">
        <div class="ps-5 pe-5 pt-8 pb-8 md:p-8">
            <p class="text-xl md:text-2xl text-[#2D2D2D] font-medium text-center mb-8">
                Заполните короткую форму
            </p>
            <div class="max-w-md mx-auto">
                <div>
                    <div class="relative z-0 w-full group">
                        <input type="tel"
                               @keyup="updatePhone($event.target.value)"
                               :value="callbackStore.forms.services_top_form.data.phone"
                               v-imask="phoneMask"
                               name="stf_phone" id="stf_phone"
                               class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                               :class="[callbackStore.forms.services_top_form.errors && callbackStore.forms.services_top_form.errors['phone'] ? 'border-red-500' : '']"
                               placeholder=" " required/>
                        <label for="stf_phone"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Номер телефона
                        </label>
                    </div>
                    <CallbackErrorMessage :error="callbackStore.forms.services_top_form.errors"
                                          :error-msg="'phone'" class="ps-0"/>
                </div>
                <div class="mt-5">
                    <div class="relative z-0 w-full  group">
                        <input v-model="callbackStore.forms.services_top_form.data.full_name" type="text"
                               name="stf_full_name" id="stf_full_name"
                               class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                               :class="[callbackStore.forms.services_top_form.errors && callbackStore.forms.services_top_form.errors['full_name'] ? 'border-red-500' : '']"
                               placeholder=" " required/>
                        <label for="stf_full_name"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Как к вам обращаться?
                        </label>
                    </div>
                    <CallbackErrorMessage :error="callbackStore.forms.services_top_form.errors"
                                          :error-msg="'full_name'" class="ps-0"/>
                </div>
                <div class="relative w-full lg:w-auto flex justify-center mt-10">
                    <button @click.prevent="callbackStore.send(callbackStore.forms.services_top_form)"
                            type="button"
                            class="flex justify-center items-center  text-white hover:text-indigo-600 border-2 border-indigo-600 bg-indigo-600 hover:bg-transparent font-medium rounded-full text-sm px-10 py-2.5 focus:outline-none transition">
                        <span class="text-base">
                            Узнать цену
                        </span>
                        <SpinnerIndicator v-if="callbackStore.forms.services_top_form.sending" class="w-6 h-6 ms-2"/>
                    </button>
                </div>
            </div>
            <PrivacyPolicyAgreementLink class="mt-5"/>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
